import React from 'react';

import { StyleSheet } from 'react-native';
import { withTypography } from 'ucl/components/text/Typography';

import { Box, BoxProps } from 'components/ui';

export const Container = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.container, style]} />
);

export const ProductTitle = withTypography({
  accessible: true,
  m: '$0',
  numberOfLines: 1,
  variant: 'headerOne',
  fontSize: 18,
  lineHeight: 25,
});

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    flexGrow: 1,
    justifyContent: 'center',
    paddingHorizontal: 64,
    width: '100%',
  },
});
